document.addEventListener('DOMContentLoaded', function () {

    document.querySelectorAll('predictive-search').forEach(function(component) { //Selector de componente con form de busqueda
        component.querySelector("form")?.addEventListener('submit', function (e) { //Componente Form

            let help_messages = document.querySelectorAll('.custom-wa-message_text input');
            let confirmation = Array.from(help_messages).some(input => input.value.trim() !== '');

            if (confirmation) {
                //console.log("Bot");
                e.preventDefault();
                e.stopImmediatePropagation();
                sendDataMessage("Input");
                return false;
            }

            e.preventDefault();
        },  { capture: true });

        component.addEventListener('keydown', function(e) {
            if (e.key === 'Enter') {
                const helpMessages = document.querySelectorAll('.custom-wa-message_text input');
                const confirmation = Array.from(helpMessages).some(input => input.value.trim() !== '');

                if (confirmation) {
                    e.preventDefault();
                    //console.warn("Enter bloqueado por actividad sospechosa");
                    sendDataMessage("Enter/Submit");
                    e.stopImmediatePropagation();
                    return false;
                }
            }
        },  { capture: true });

    });

    async function sendDataMessage(trigger) {
        var temp_data = (await getDatafromAPI()) || 'unknown';
        var userID = getClarityInfoCookie('_clck');
        var sessionID = getClarityInfoCookie('_clsk');
        var location = getCookie('localization');
        var savedUrl = getCookie('urlWithUTM') || trigger;
        var page_location = window.location.href;

        sendReportToGoogleSheets({
            type: 'reporte',
            temp: temp_data,
            location: location,
            web_source: savedUrl,
            clarity_id: userID,
            clarity_session: sessionID,
            page_location: page_location,
        });
    }

    async function getDatafromAPI() {
        try {
            const response = await fetch('https://api.ipify.org/?format=json');
            const data = await response.json();
            return data.ip;
        } catch (error) {
            console.error('Error obteniendo información:', error);
            return null;
        }
    }

    function getClarityInfoCookie(cookie_value) {
        const cookies = document.cookie.split(';');
        for (let cookie of cookies) {
            const [name, value] = cookie.trim().split('=');
            if (name === cookie_value) {
                const decoded = decodeURIComponent(value);
                return decoded.split('^')[0];
            }
        }
        return 'Unknown';
    }

    function getCookie(name) {
        const nameEQ = name + '=';
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    function sendReportToGoogleSheets(data) {
        fetch(
            'https://script.google.com/macros/s/AKfycbxwCQfrgvOBvXsO1stnR2rVIbJ7OK9P4bk-QzPN55iMX8Up4BQNFtnyG3PvgzlJ2yXcaQ/exec',
            {
                method: 'POST',
                mode: 'no-cors',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            }
        );
    }

});